import React, { useCallback, useContext } from "react";

import { Slide } from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import FoodDatabase from "@/components/FoodDatabase";
import MealPatternDatabase from "@/components/FoodDatabase/MealPatternDatabase";
import {
  PlannedFood,
  PlannedFoodPortion,
} from "@/components/FoodDatabase/utils";
import {
  FoodAddPortionDetailsFragment,
  FoodItemFragment,
  MealPatternNameKind,
} from "@/gql/graphql";

import MealPlanFormStore from "../store/MealPlanFormStore";

const useStyles = makeStyles()((theme) => ({
  foodDatabase: {
    alignSelf: "flex-start",
    position: "sticky",
    top: theme.spacing(4),
    width: "calc(30% - 12px)",
    marginLeft: theme.spacing(2),
    verticalAlign: "top",
    zIndex: 10,
  },
  foodDatabaseOpen: {
    display: "block",
  },
  foodDatabaseClose: {
    display: "none",
  },
}));

const SearchFoodPanel: React.FC = observer(() => {
  const { classes, cx } = useStyles();

  const store = useContext(MealPlanFormStore.Context);
  const activeCell = store.cells.active;
  const foodDatabaseOpen = !!activeCell;

  const handleAddFood = useCallback(
    (
      food: FoodItemFragment,
      foodPortion: FoodAddPortionDetailsFragment,
      amount: number
    ) => {
      if (activeCell == null) return;
      activeCell.addPlannedMealItem(food, foodPortion, amount);
    },
    [activeCell]
  );

  const handleAddMealPattern = useCallback(
    (
      name: MealPatternNameKind,
      amountServings: number,
      food: PlannedFood,
      foodPortion: PlannedFoodPortion
    ) => {
      if (activeCell == null) return;
      activeCell.addMealPatternItem(name, amountServings, food, foodPortion);
    },
    [activeCell]
  );

  return (
    <Slide in={foodDatabaseOpen} direction="left">
      <div
        className={cx(classes.foodDatabase, {
          [classes.foodDatabaseOpen]: foodDatabaseOpen,
          [classes.foodDatabaseClose]: !foodDatabaseOpen,
        })}
      >
        {activeCell?.mode === "meal_pattern_item" ? (
          <MealPatternDatabase
            onClose={() => store.cells.clearActive()}
            onAddMealPattern={handleAddMealPattern}
          />
        ) : (
          <FoodDatabase
            onClose={() => store.cells.clearActive()}
            onAddFood={handleAddFood}
            clientAllergies={store.clientAllergies}
          />
        )}
      </div>
    </Slide>
  );
});

export default SearchFoodPanel;
